import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetProducts } from "../../hooks/groups/Products";
import GroupProductsListItem from "./GroupProductsListItem";
import GroupProductsEditForm from "./GroupProductsEditForm";
import LoadingSpinner from "../global/LoadingSpinner";

function GroupProductsList({ id }) {
    const { t } = useTranslation();
    const { data: productsData, isLoading, isError } = useGetProducts(id);
    const [isNew, setIsNew] = useState(false)

    const handleNew = () => {
        setIsNew(true);
    }

    if (isLoading) return <LoadingSpinner/>
    if (isError) return 'An error has occurred: ' + isError.message;

   // if (productsData) return <pre>{id}{JSON.stringify(productsData, null,2)}</pre>;

    return (
        <>
            {productsData.map((product, key) => {
                return (<GroupProductsListItem key={product.id} id={product.id} moduleId={id} product={product} />)
            })}
            {isNew && (<div className="productSingle"><GroupProductsEditForm id={null} moduleId={id} onClose={() => setIsNew(false)} /> </div>)}
                <div className="productNew">
                    <button onClick={() => handleNew()}
                        className="btn btn-default btn-save"
                        title={t("admin.group.addE")}>{t("admin.group.addE")}</button>
                </div>
        </>
    );
}

export default GroupProductsList;
